module.exports = __webpack_public_path__ + "img/Phone.4e02dee7.webp";